const subscribeBackInStock = (contact, variantId, channel = 'EMAIL') => {
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      revision: '2024-06-15',
    },
    body: JSON.stringify({
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                [channel === 'EMAIL' ? 'email' : 'phone_number']: contact,
              },
            },
          },
          channels: [channel],
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variantId}`,
            },
          },
        },
      },
    }),
  };

  return fetch(
    `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.theme.klaviyoSettings.companyId}`,
    options,
  );
};

const subscribeToList = (contact, channel = 'EMAIL') => {
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      revision: '2024-06-15',
    },
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                [channel === 'EMAIL' ? 'email' : 'phone_number']: contact,
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: window.theme.klaviyoSettings.backInStockListId,
            },
          },
        },
      },
    }),
  };

  return fetch(
    `https://a.klaviyo.com/client/subscriptions/?company_id=${window.theme.klaviyoSettings.companyId}`,
    options,
  );
};

const subscribe = async (contact, consent, variantId, channel) => {
  if (!contact || contact.length === 0) return Promise.reject(new Error('Email is missing'));
  if (!variantId) return Promise.reject(new Error('Variant ID is missing'));

  try {
    const response = await subscribeBackInStock(contact, variantId, channel);

    if (response.status === 400) {
      const json = await response.json();

      return Promise.reject(new Error(json?.errors[0]?.detail));
    }

    if (consent) {
      await subscribeToList(contact, channel);
    }

    return Promise.resolve();
  } catch (err) {
    return Promise.reject(err);
  }
};

export default subscribe;
